import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import classNames from "classnames";
import { useRouter } from "next/router";

import LinkButton from "@/components/Button/LinkButton";
import Button from "@/shared/components/Button/Button";
import SharePopup from "@/components/SharePopup/SharePopup";
import { useModalContext } from "@/shared/contexts/modal";
import { useSubscriptionsContext } from "@/contexts/subscriptions";
import { BookCircle } from "../../../assets/CommonIcons";
import { makeChapterUrl } from "@/utils/routes/routes";
import { cropHtmlContent, makeSubsReadUrl } from "@/shared/utils/subscriptions";
import { getShareData } from "./Subscriptions.utils";
import IconView from "@/shared/components/IconView/IconView";
import EgwWebFont from "src/assets/EgwWebFont";
import dynamic from "next/dynamic";

import styles from "./subscriptions.module.scss";


const BookCover = dynamic(() =>
  import("@/shared/components/BookCoverView"), { ssr: false });

const SubsItem = ({ item, width, index }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { date, unsubscribe } = useSubscriptionsContext();
  const { showDialog } = useModalContext();

  const [content, setContent] = useState(item.content.join(""));

  useEffect(() => {
    if (!width) {
      return;
    }

    setContent(cropHtmlContent(width, item.content, false));
  }, [width]);

  const onOpenHandler = () => {
    router.push(makeSubsReadUrl(date, item.book_id));
  };

  const onSubscribeHandler = () => {
    showDialog(
      t("deleteSub"),
      t("deleteSubWarn", { title: item.book_title }),
      () => {
        unsubscribe(item.subscription);
      },
      { className: styles["delete-sub-container"] },
    );
  };

  const shareData = getShareData(item);

  return (
    <div key={index} className={styles["subs-item"]}>
      <div className={styles["subs-item-img-container"]}>
        <div className={styles["subs-item-img"]} onClick={onOpenHandler}>
          <div className={styles["subs-item-tap"]}>
            <span className={styles["subs-item-tap-text"]}>{t("read")}</span>
            <BookCircle />
          </div>
          <BookCover book={item} />
        </div>
        <div className={styles["subs-item-actions"]}>
          <SharePopup
            {...shareData}
            renderButton={({ show, onClick }) => {
              return (
                <Button
                  className={styles["subs-item-action"]}
                  title={t("share")}
                  active={show}
                  onClick={onClick}
                >
                  <IconView icon={EgwWebFont.share} className={styles["subs-item-action-icon"]} />
                </Button>
              );
            }}
          />
          <Button
            className={styles["subs-item-action"]}
            title={item.subscription ? t("subscribed") : t("subscribe")}
            onClick={onSubscribeHandler}>
            <IconView
              icon={EgwWebFont["subscription-outline"]}
              className={classNames(
                styles["subs-item-action-icon"],
                styles["subs-item-action-icon-selected"],
              )}
            />
          </Button>
          <LinkButton
            href={makeChapterUrl(item.start_para_id)}
            className={styles["subs-item-action"]}
            title={t("read")}>
            <IconView icon={EgwWebFont.read} className={styles["subs-item-action-icon"]} />
          </LinkButton>
        </div>
      </div>
      <div className={styles["subs-item-description"]} onClick={onOpenHandler}>
        <h3 className={styles["subs-item-title"]}>{item.label}</h3>
        <div
          className={styles["subs-item-content"]}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

SubsItem.propTypes = {
  item: PropTypes.object,
  width: PropTypes.number,
  index: PropTypes.number,
};

export default SubsItem;
